import { motion } from "framer-motion";
import { ShieldCheck, LockKeyhole } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export function PrivacyPanel() {
  return (
    <section id="privacy" className="mx-auto max-w-7xl scroll-mt-24 px-4 pb-24 sm:px-6 sm:pb-32 lg:px-8">
      <motion.div
        data-testid="privacy-panel"
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="relative overflow-hidden rounded-3xl bg-olive p-8 sm:p-12"
      >
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-acid/20 blur-3xl"
        />
        <div className="relative grid gap-10 md:grid-cols-2">
          <div>
            <div className="flex items-center gap-2.5">
              <ShieldCheck size={22} className="text-acid" strokeWidth={2.5} />
              <h2 className="font-display text-2xl font-bold tracking-tight text-paper sm:text-3xl">
                100% on-device
              </h2>
            </div>
            <p className="mt-4 max-w-md text-[15px] leading-relaxed text-[#E1E2E6]">
              Your messages are analyzed right on your own phone, inside the app. We never upload,
              store, or see a single DM. It even works fully offline.
            </p>
          </div>
          <div className="md:border-l md:border-acid/20 md:pl-10">
            <div className="flex items-center gap-2.5">
              <LockKeyhole size={20} className="text-paper/70" strokeWidth={2.5} />
              <h3 className="font-display text-lg font-bold tracking-tight text-paper/80">Heads up</h3>
            </div>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-paper/60">
              End-to-end encrypted chats aren't included in Instagram exports, so they won't show up
              in your report.
            </p>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
